import React from 'react';
import { graphql, usePreloadedQuery, type EntryPointProps } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { DashboardsContentRefactored } from '../../../../common/ui/content/DashboardsContentRefactored.tsx';
import type { DashboardsContentViewRefactoredQuery } from './__generated__/DashboardsContentViewRefactoredQuery.graphql';

type Queries = { queryRef: DashboardsContentViewRefactoredQuery };

export default function DashboardsContentViewRefactoredQuery({
	queries: { queryRef },
}: EntryPointProps<Queries, {}, Partial<EntryPointRouteParams>, {}>): React.JSX.Element {
	const data = usePreloadedQuery<DashboardsContentViewRefactoredQuery>(
		graphql`
			query DashboardsContentViewRefactoredQuery($cloudId: ID!, $entityAri: ID!, $ownerAri: ID!)
			@preloadable {
				...DashboardsContentRefactored
			}
		`,
		queryRef,
	);

	return <DashboardsContentRefactored queryRef={data} />;
}
